import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';
import { ClinicFragment } from '@/graphql/types-and-hooks';

export type SearchClinicType = 'booking' | 'script' | 'referral';

type State = {
  clinic: ClinicFragment | null;
  type: SearchClinicType | null;
};

type Actions = {
  setData: (data: Partial<State>) => void;
  resetData: (data?: (keyof State)[]) => void;
};

const initialState: State = {
  clinic: null,
  type: null,
};

const useSearchClinicStoreBase = createWithEqualityFn<State & Actions>()(set => ({
  ...initialState,
  setData: data =>
    set(state => ({
      ...state,
      ...data,
    })),
  resetData: (data) =>
    set((state) => {
      if (!data) return { ...initialState };

      data.forEach((name: keyof State) => {
        if (name === 'clinic') {
          state.clinic = initialState.clinic; // Type-safe assignment for 'clinic'
        } else if (name === 'type') {
          state.type = initialState.type; // Type-safe assignment for 'type'
        }
      });

      return state;
    }),
}));

export const useSearchClinicStore = <U>(
  selector: (state: State & Actions) => U
) => {
  return useSearchClinicStoreBase(selector, shallow);
};
